import { debounce } from '@chatwoot/utils';
import {
  MODAL_PAGE_SIZE,
  SEARCH_DEBOUNCE_MS,
  TEST_IDS,
} from '../constants/subcategoriesBarConstants';
import {
  buildSubcategoryHref,
  slugifySubcategory,
} from '../subcategoriesBarUtils';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    subcategories: {
      type: Array,
      required: true,
    },
    selectedSubcategory: {
      type: String,
      default: null,
    },
    basePath: {
      type: String,
      required: true,
    },
    translations: {
      type: Object,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      searchTerm: '',
      appliedSearchTerm: '',
      isFiltering: false,
      currentPage: 1,
    };
  },
  computed: {
    filteredSubcategories() {
      const query = this.appliedSearchTerm.trim().toLowerCase();
      if (!query) {
        return this.subcategories;
      }
      return this.subcategories.filter(subcategory =>
        subcategory.toLowerCase().includes(query)
      );
    },
    totalPages() {
      return Math.max(
        1,
        Math.ceil(this.filteredSubcategories.length / MODAL_PAGE_SIZE)
      );
    },
    paginatedSubcategories() {
      const start = (this.currentPage - 1) * MODAL_PAGE_SIZE;
      return this.filteredSubcategories.slice(start, start + MODAL_PAGE_SIZE);
    },
    hasResults() {
      return this.filteredSubcategories.length > 0;
    },
  },
  watch: {
    searchTerm() {
      this.isFiltering = true;
      this.debouncedApplySearch();
    },
  },
  created() {
    this.TEST_IDS = TEST_IDS;
    this.debouncedApplySearch = debounce(this.applySearch, SEARCH_DEBOUNCE_MS);
  },
  methods: {
    applySearch() {
      this.appliedSearchTerm = this.searchTerm;
      this.currentPage = 1;
      this.isFiltering = false;
    },
    onSearchInput(value) {
      this.searchTerm = value;
    },
    onPageChange(newPage) {
      this.currentPage = newPage;
    },
    subcategoryHref(subcategory) {
      return buildSubcategoryHref(this.basePath, subcategory);
    },
    rowTestId(subcategory) {
      return `${TEST_IDS.MODAL_ROW_PREFIX}-${slugifySubcategory(subcategory)}`;
    },
    isRowActive(subcategory) {
      return (
        Boolean(this.selectedSubcategory) &&
        subcategory.toLowerCase() === this.selectedSubcategory.toLowerCase()
      );
    },
    closeModal() {
      this.onClose();
    },
  },
};
